export const parseSessionData = (str) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
};
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
